import { CSSProperties, FC, PropsWithChildren } from 'react';

import { TColorProp } from 'styled-components';

import { satoshi } from '~/common/styles/fonts';

import { Container, TSubheadingSize } from './styles';

interface ISubheadingProps extends PropsWithChildren {
  size: TSubheadingSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
}

export const Subheading: FC<ISubheadingProps> = ({
  size,
  color = 'neutral100',
  children,
  style,
  href,
}) => {
  return (
    <Container
      $size={size}
      $color={color}
      className={satoshi.className}
      style={style}
      {...(href && {
        as: 'a',
        href,
      })}
    >
      {children}
    </Container>
  );
};
